import Svg, { Defs, LinearGradient, Path, Stop } from 'react-native-svg'

const Union = ({ width = 16, height = 19, color = '#fff' }: any) => (
  <Svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none">
    <Path
      fill="url(#a)"
      fillRule="evenodd"
      d="M11.364 3.788a3.788 3.788 0 1 1-7.576 0 3.788 3.788 0 0 1 7.576 0Zm3.787 9.943c0 2.877-3.391 5.208-7.575 5.208S0 16.608 0 13.731c0-2.876 3.392-5.208 7.576-5.208 4.184 0 7.576 2.332 7.576 5.208Z"
      clipRule="evenodd"
    />
    <Defs>
      <LinearGradient id="a" x1={6.854} x2={15.676} y1={0.451} y2={22.051} gradientUnits="userSpaceOnUse">
        <Stop offset={0.011} stopColor={color} />
        <Stop offset={1} stopColor={color} stopOpacity={0.16} />
      </LinearGradient>
    </Defs>
  </Svg>
)
export default Union
